"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MenuItem = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var component_library_1 = require("@kaizen/component-library");
var MenuItem_module_scss_1 = __importDefault(require("./MenuItem.module.scss"));
var MenuItem = function (props) {
    var label = props.label, icon = props.icon, action = props.action, destructive = props.destructive, disabled = props.disabled, automationId = props.automationId, onClick = props.onClick, href = props.href, target = props.target, isActive = props.isActive;
    var wrappedLabel = react_1["default"].createElement("span", { className: MenuItem_module_scss_1["default"].menuItem__Label }, label);
    var iconNode = icon && (react_1["default"].createElement("span", { className: MenuItem_module_scss_1["default"].menuItem__Icon },
        react_1["default"].createElement(component_library_1.Icon, { icon: icon, role: "presentation" })));
    var className = (0, classnames_1["default"])(MenuItem_module_scss_1["default"].menuItem, destructive && MenuItem_module_scss_1["default"]["menuItem--destructive"], disabled && MenuItem_module_scss_1["default"]["menuItem--disabled"], isActive && MenuItem_module_scss_1["default"]["menuItem--active"]);
    // Use the legacy `action` property, if the new onClick or href as not supplied
    var onClickCombined = onClick != null ? onClick : typeof action !== "string" ? action : undefined;
    var hrefCombined = href != null ? href : typeof action === "string" ? action : undefined;
    if (disabled) {
        return (react_1["default"].createElement("li", { className: MenuItem_module_scss_1["default"].menuListItem },
            react_1["default"].createElement("button", { type: "button", disabled: true, className: className, "data-automation-id": automationId, "data-testid": automationId },
                iconNode,
                wrappedLabel)));
    }
    if (hrefCombined) {
        return (react_1["default"].createElement("li", { className: MenuItem_module_scss_1["default"].menuListItem },
            react_1["default"].createElement("a", { href: hrefCombined, onClick: onClickCombined, className: className, "data-automation-id": automationId, "data-testid": automationId, target: target, "aria-current": isActive ? "page" : undefined },
                iconNode,
                wrappedLabel)));
    }
    return (react_1["default"].createElement("li", { className: MenuItem_module_scss_1["default"].menuListItem },
        react_1["default"].createElement("button", { type: "button", onClick: onClickCombined, className: className, "data-automation-id": automationId, "data-testid": automationId },
            iconNode,
            wrappedLabel)));
};
exports.MenuItem = MenuItem;
exports.MenuItem.displayName = "MenuItem";
//# sourceMappingURL=MenuItem.js.map